import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

interface SaveAllSectionProps {
    isLoading: boolean;
    onSaveAll: () => void;
}

export const SaveAllSection: React.FC<SaveAllSectionProps> = ({
    isLoading,
    onSaveAll
}) => {
    return (
        <Card className="mt-4 shadow-2">
            <div className="flex justify-content-center">
                <Button
                    label="Save All Summaries"
                    icon="pi pi-save"
                    className="p-button-lg p-button-success"
                    loading={isLoading}
                    onClick={onSaveAll}
                    disabled={isLoading}
                />
            </div>
        </Card>
    );
};